import { makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { FC } from 'react';

import Link, { Properties } from '.';
import { Theme } from '../style-context';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.name === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      color: theme.name === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
}));

export const ContrastLink: FC<Properties> = ({ children, className, ...rest }) => {
  const classes = useStyles();

  return (
    <Link className={classes.root} {...rest}>
      {children}
    </Link>
  );
};

export default ContrastLink;
